import { NextPage } from 'next';

import Login from '@/components/Login';

const LoginPage: NextPage = () => {
  return <Login />;
};

export default LoginPage;
